import { userPath } from '../../../api/apiPaths';
import { get, put } from '../../../api/commonAPI';
import toastr from 'toastr';
import {
  FETCH_ALL_USERS,
  FETCH_ALL_USERS_SUCCESS,
  FETCH_ALL_USERS_FAIL,
  FETCH_USERS_BY_USERNAME,
  FETCH_USERS_BY_USERNAME_SUCCESS,
  FETCH_USERS_BY_USERNAME_FAIL,
  RESET_USER_DATA,
  CHANGE_ADMIN_ROLE,
  CHANGE_ADMIN_ROLE_SUCCESS,
  CHANGE_ADMIN_ROLE_FAILS,
} from './CreateAdminActionType';

export const fetchAllUsers = (page, size, sort, order) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_ALL_USERS });

    const url = `${userPath}/all?page=${page}&size=${size}&sort=${sort}&order=${order}`;

    try {
      const res = await get(url);
      dispatch({
        type: FETCH_ALL_USERS_SUCCESS,
        payload: res.data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_ALL_USERS_FAIL,
        payload: error,
      });
    }
  };
};

export const findByUsernameOrEmail = (text) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_USERS_BY_USERNAME });

    const url = `${userPath}/?username=${text}`;

    try {
      const res = await get(url);
      dispatch({
        type: FETCH_USERS_BY_USERNAME_SUCCESS,
        payload: res.data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_USERS_BY_USERNAME_FAIL,
        payload: error,
      });
      toastr.error('Invalid input');
    }
  };
};

export const changeRole = (userId, action) => {
  return async (dispatch) => {
    dispatch({ type: CHANGE_ADMIN_ROLE });

    const url = `${userPath}/role/${userId}/assign?action=${action}`;

    try {
      const res = await put(url);
      dispatch({
        type: CHANGE_ADMIN_ROLE_SUCCESS,
        payload: res.data,
      });

      toastr.success(action ? 'User Assigned' : 'User Unassigned');
    } catch (error) {
      dispatch({
        type: CHANGE_ADMIN_ROLE_FAILS,
        payload: error,
      });

      const errorMsg = 'Failed to update user role check Email';
      toastr.error(errorMsg);
    }
  };
};

export const resetUserData = () => ({
  type: RESET_USER_DATA,
});
